import React, { useEffect, useState } from 'react';
import { WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner } from '@components';
import { Wrapper } from '@components/session-expiry-banner/styled.tsx';
import { TEST_IDS } from '@constants/testIds.ts';
import { Trans } from '@lingui/react/macro';
import { SESSION_EXPIRY_WARNING_MS } from '@routes/auth/___shared___/sessionExpiryScheduler.ts';

const SESSION_EXPIRY_WARNING_SECONDS = SESSION_EXPIRY_WARNING_MS / 1000;

export const SessionExpiryBanner: React.FC = () => {
    const [secondsLeft, setSecondsLeft] = useState(SESSION_EXPIRY_WARNING_SECONDS);

    useEffect(() => {
        const interval = window.setInterval(() => {
            setSecondsLeft((prev) => Math.max(prev - 1, 0));
        }, 1000);

        return () => {
            window.clearInterval(interval);
        };
    }, []);

    if (secondsLeft === 0) return null;

    return (
        <Wrapper data-cy={TEST_IDS.SHARED.SESSION_EXPIRY_BANNER}>
            <BaseAlertBanner
                type="warning"
                title={
                    <Trans>
                        <strong>You have been inactive for a while.</strong>
                    </Trans>
                }
                description={
                    <Trans>
                        If no activity is detected you will be logged out. Remaining seconds left:{' '}
                        <strong>{String(secondsLeft).padStart(2, '0')}</strong>
                    </Trans>
                }
                icon={<WarningFilled />}
            />
        </Wrapper>
    );
};
